import { useCallback, useState } from 'react';

export interface UseCameraReturn {
  capture: () => Promise<File | null>;
  isCapturing: boolean;
  error: string | null;
}

export function useCamera(): UseCameraReturn {
  const [isCapturing, setIsCapturing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const capture = useCallback((): Promise<File | null> => {
    return new Promise((resolve) => {
      setIsCapturing(true);
      setError(null);

      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.capture = 'environment'; // Back camera on mobile

      input.onchange = (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        setIsCapturing(false);
        if (file) {
          // Validate it's an image
          if (!file.type.startsWith('image/')) {
            setError('Please select an image file');
            resolve(null);
            return;
          }
          resolve(file);
        } else {
          resolve(null);
        }
      };

      // Handle cancel
      input.oncancel = () => {
        setIsCapturing(false);
        resolve(null);
      };

      // Handle errors
      input.onerror = () => {
        setIsCapturing(false);
        setError('Failed to access camera');
        resolve(null);
      };

      input.click();
    });
  }, []);

  return { capture, isCapturing, error };
}
